export default "<i class=\"material-icons\">{{item.icon}}</i>\n<span>{{item.label | async}}</span>"